import { render, staticRenderFns } from "./Yszsyqktj.vue?vue&type=template&id=4071cd1c&scoped=true&"
import script from "./Yszsyqktj.vue?vue&type=script&lang=js&"
export * from "./Yszsyqktj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4071cd1c",
  null
  
)

export default component.exports